import { find } from 'lodash';
import { isTeacher } from 'utils/authScopes';

export const ASQ_COMPLETE = 'asq:complete';
export const CONTENT_LIBRARY_VIEW = 'content_library:view';
const FLAG_NEW_COMMUNICATION_DASHBOARD = 'flag:new_communication_dashboard';

export const hasFeature = (auth, key) => {
  const feature = find(auth.features, { key: key });

  return feature && feature.enabled;
};

const generateFeatureCheck = (key) => {
  return (auth) => {
    return hasFeature(auth, key);
  };
};

// export const hasASQCompleteFeature = generateFeatureCheck('asq:complete');
export const hasASQCompleteFeature = (auth) => {
  return (isTeacher(auth) || hasFeature(auth, ASQ_COMPLETE));
}

export const hasContentLibraryViewFeature = generateFeatureCheck(CONTENT_LIBRARY_VIEW);

export const hasNewCommunicationDashboardFeature = generateFeatureCheck(FLAG_NEW_COMMUNICATION_DASHBOARD);
